import tabla_usuarios from "../../../components/shared/tabla/tabla.vue"
import CryptoJS from "crypto-js";
import * as XLSX from 'xlsx'

export default {

  components: { tabla_usuarios },
  data() {
    return {
      dialogMensualAnual: true,
      tipo: true, //compras y ventas true cierra anual false
      item: "",
      lodingData: false,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,
      facturas: [],
      totalFacturas: "",

      facturas_recibidas: [],
      totalFacturas_recibidas: "",
      loading: false,

      data_fecha: {
        fecha_usuario: "",
        fecha: ""
      },

      items: [2022, 2023, 2024, 2025, 2026, 2027],

      select: "",
      declaraciones: [],


      loadingFacturas: false,
      laodingRecibidas: false,

      totales_facturas: 0,
      totales_retenciones: 0,
      totales_impuesto: 0,


      anio_auxiliar: '',
      loading_pdf: false,
    }
  },

  created() {

    let informacion_incriptada = sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-todo');
    if (informacion_incriptada != null) {
      let key_pass = atob(sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-tic'))
      let bytes = CryptoJS.AES.decrypt(informacion_incriptada, key_pass + "byTeamT0d0T1c");
      //Casteo de información a estring
      let informacion_desincriptada = bytes.toString(CryptoJS.enc.Utf8);
      //Casteo de JSON String a Object json
      let r = JSON.parse(informacion_desincriptada)
      // console.log("data encriptada");
      console.log(r);
      this.item = r.usuario[0]

    }
    // this.getUsuarios();
  },

  methods: {

    async exportarPdfAnual() {

      console.log("anio auxliar");
      console.log(this.anio_auxiliar);
      console.log("item");
      console.log(this.item);
      try {
        this.loading_pdf = true;
        let r = await this.$store.state.services.reportesService.obtenerCierreAnual(this.anio_auxiliar, this.item.id);
        console.log(r);
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = r.data.data
        link.setAttribute('download', `${this.item.cui}_${this.item.nombre}_CIERRE_ANUAL.pdf`)
        document.body.appendChild(link)
        link.click()
        this.loading_pdf = false;
      } catch (error) {
        console.log(error);
        this.loading_pdf = false;
        this.$toast.error("No es posible procesar la información");
      }

    },

    async exportarPdf() {
      console.log(this.data_fecha.fecha_usuario);
      console.log("item");
      console.log(this.item);
      try {
        this.loading_pdf = true;
        let r = await this.$store.state.services.reportesService.obtenerPdfComprasVentas(this.item.id, this.data_fecha.fecha_usuario.split("/")[0], this.data_fecha.fecha_usuario.split("/")[1]);
        console.log(r);

        await this.exportarExcel(1, this.facturas);
        await this.exportarExcel(2, this.facturas_recibidas);

        setTimeout(() => {
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = r.data.data
          link.setAttribute('download', `${this.item.cui}_LTE.pdf`)
          document.body.appendChild(link)
          link.click()
        }, 1 * 1000);
        this.loading_pdf = false;

      } catch (error) {
        console.log(error);
        this.loading_pdf = false;
        this.$toast.error("No es posible procesar la información");
      }
    },

    convertirnumero(numero) {
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(Math.abs(numero))

    },

    async getListadoDeclaracionesInicial() {
      if (this.tipo) {
        this.data_fecha.fecha_usuario = this.date.split("-")
          .reverse()
          .join("/");

        let fecha = this.data_fecha.fecha_usuario.split("/");

        this.data_fecha.fecha = this.date;

        //VENTAS
        try {
          this.loadingFacturas = true;
          let r =
            await this.$store.state.services.presentacionService.postlibrosVentas({ fecha: fecha[0] + "/" + fecha[1], usuario_id: this.item.id });
          console.log("libros de ventas");
          console.log(r);

          this.facturas = r.data.data.facturas;

          let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });

          let total = r.data.data.total_facturas;

          this.totalFacturas = dollarUSLocale.format(total);
          this.loadingFacturas = false;


        } catch (error) {
          console.log(error);
          this.$toast.info(
            "No se encontraron coincidencias"
          );
          this.loadingFacturas = false;

        }
        //COMPRAS
        try {
          this.laodingRecibidas = true;
          let r =
            await this.$store.state.services.presentacionService.postlibrosCompras({ fecha: fecha[0] + "/" + fecha[1], usuario_id: this.item.id });
          console.log("libros de compras");
          console.log(r);

          this.facturas_recibidas = r.data.data.facturas;

          let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });

          let total = r.data.data.total_facturas;

          this.totalFacturas_recibidas = dollarUSLocale.format(total);
          this.laodingRecibidas = false;

        } catch (error) {
          console.log(error);
          this.$toast.info(
            "No se encontraron coincidencias"
          );
          this.laodingRecibidas = false;

        }
      } else {


        try {
          this.lodingData = true;

          let r =
            await this.$store.state.services.presentacionService.postCierreAnual({ anio: this.select, usuario_id: this.item.id });
          console.log("informe final");
          console.log(r);
          this.anio_auxiliar = '';
          this.totales_facturas = 0;
          this.totales_impuesto = 0;
          this.totales_retenciones = 0;
          this.declaraciones = [];
          this.declaraciones = r.data.data;

          this.declaraciones.forEach(element => {
            this.totales_facturas = this.totales_facturas + element.total_factura
          });


          this.declaraciones.forEach(element => {
            this.totales_retenciones = this.totales_retenciones + element.total_retencion
          });


          this.declaraciones.forEach(element => {
            this.totales_impuesto = this.totales_impuesto + element.impuesto
          });


          this.lodingData = false;
          this.anio_auxiliar = this.select;
          this.select = '';

        } catch (error) {
          console.log(error);
          this.$toast.info(
            "No se encontraron coincidencias"
          );
          this.lodingData = true;
        }
      }

    },

    exportarExcel(tipo, items) {


      // si items no tiene datos, no se puede exportar
      if (items.length === 0) {
        return;
      }

      console.log("exportarExcel", tipo);
      let data = XLSX.utils.json_to_sheet(items)
      const workbook = XLSX.utils.book_new()
      let filename = ''
      if (tipo == 1) {
        filename = 'facturas_emitidas' + this.item.nit;
      } else if (tipo == 2) {
        filename = 'facturas_recibidas' + this.item.nit;
      }
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },

  },
}